import * as React from "react"
import Layout from "../../components/Layout/Layout"
import Helmet from "react-helmet"
import Title from "../../components/Title/Title"
import BreadcrumbBar from "../../components/BreadcrumbBar/BreadcrumbBar"
import Box from "../../components/Box/Box"

function Expectations() {
    const parentPages = [{name: "Home", path: "/"}, {name: "Osteopathy", path: "/osteopathy"}]

    return (
        <Layout>
            <Helmet>
                <title>What to Expect | Desborough Osteopaths</title>

                <meta charSet="utf-8" />
                <html lang="en" />
            </Helmet>
            <Title title="What to Expect" />
            <BreadcrumbBar currentPage="What to Expect" parentPages={parentPages} />
            <section>
                <div style={{width: 'min(90%, 800px)', margin: 'auto'}}>
                    <h2>Amet ipsum id id aliquip magna</h2>
                    <p>Est cillum laboris veniam veniam id sint deserunt consequat enim culpa cillum ex minim nulla. Minim anim reprehenderit excepteur consectetur cupidatat aute ut magna pariatur incididunt labore. Non ex velit sit voluptate fugiat fugiat tempor. Sint aliqua est elit exercitation ea sint fugiat. Ipsum fugiat laboris dolor aliquip id laboris ex. Quis amet nostrud Lorem enim consectetur adipisicing culpa nostrud id dolor.</p>
                    <Box heading="Step 1">
                        <p>Tempor aute minim Lorem laboris sunt ipsum reprehenderit aute eiusmod nostrud. In eiusmod quis cupidatat consectetur incididunt excepteur irure culpa dolore duis cupidatat. Non incididunt aute nostrud deserunt. Sint dolor sint velit pariatur proident culpa laboris dolor elit id. Aute proident fugiat voluptate irure id nulla. Eiusmod aliqua eiusmod nulla excepteur fugiat nisi irure quis laboris anim fugiat.</p>
                    </Box>
                    <Box heading="Step 2">
                        <p>Aliquip qui et elit deserunt aute Lorem incididunt. Excepteur culpa consequat ut sit. Non fugiat laboris ipsum eu labore labore ea nulla. Cillum Lorem ipsum adipisicing commodo esse pariatur ipsum. Nulla ad adipisicing voluptate mollit cillum excepteur ipsum ea ea eu do est cillum. Veniam incididunt minim in proident do enim aute commodo aliqua sunt mollit ad cupidatat in. Ex et voluptate exercitation ipsum in ut sit velit cillum excepteur aute.</p>
                    </Box>
                    <Box heading="Step 3">
                        <p>Commodo esse pariatur laboris eiusmod non dolor sit dolore magna dolor veniam. Voluptate voluptate amet ullamco deserunt et consequat laboris ad eiusmod officia culpa anim sunt dolor. Nulla pariatur non officia qui et. Nulla veniam do irure labore nisi duis ex velit nostrud. Lorem Lorem ullamco anim voluptate aliquip cillum.</p>
                    </Box>
                </div>
            </section>
        </Layout>
    )
}

export default Expectations